export type RoutineVideoKind = 'external' | 'internal';

export enum SubmissionVideoKind {
  Interior = 1,
  Exterior = 2
}

export interface SubmissionVideoLink {
  url: string;
  uploadedAt: string;
}

export enum SubmissionRoutineTypeId {
  PreTrip = 1,
  PostTrip = 2,
  PreShift = 3,
  PostShift = 4,
  DailyDualPhase = 5,
  WeeklyDualPhase = 6
}

export function resolveInspectionTypeId(
  taskRoutineTypeId: number | null,
  phase: 'pre' | 'post'
): number | null {
  switch (taskRoutineTypeId) {
    case SubmissionRoutineTypeId.PreTrip:
      return phase === 'pre' ? SubmissionRoutineTypeId.PreTrip : null;
    case SubmissionRoutineTypeId.PostTrip:
      return phase === 'post' ? SubmissionRoutineTypeId.PostTrip : null;
    case SubmissionRoutineTypeId.PreShift:
      return phase === 'pre' ? SubmissionRoutineTypeId.PreShift : null;
    case SubmissionRoutineTypeId.PostShift:
      return phase === 'post' ? SubmissionRoutineTypeId.PostShift : null;
    case SubmissionRoutineTypeId.DailyDualPhase:
      return phase === 'pre' ? SubmissionRoutineTypeId.PreTrip : SubmissionRoutineTypeId.PostTrip;
    case SubmissionRoutineTypeId.WeeklyDualPhase:
      return phase === 'pre' ? SubmissionRoutineTypeId.PreShift : SubmissionRoutineTypeId.PostShift;
    default:
      return null;
  }
}

export interface RoutineVideo {
  kind: RoutineVideoKind;
  title: string;
  phaseLabel: string;
  capturedAt: string;
  videoUrl: string;
  inspectionTypeId: number;
  submissionVideoKind: SubmissionVideoKind;
  thumbnailUrl?: string;
}
